export function sortByKey(array: any, key: string) {
  return array.sort((a: any, b: any) => {
    const x = a[key]
    const y = b[key]

    return x < y ? -1 : x > y ? 1 : 0
  })
}
